import { getDLTypeDescription } from '@/stores/services/utils/validationUtils'

export const typeMapping = {
  EMERCONTACT: {
    cartInstructions: 'EMERCONTINCARTTXT',
    completeInstructions: 'EMERCONTACTTRNCMPTXT',
    printProduct: false,
    physicalProduct: false,
    icon: 'ri-id-card-fill',
    editPage: { name: 'AddEmergencyContact' },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: false,
  },

  DLSBLTR: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'DOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-id-card-fill',
    editPage: '',
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  DLRENEW: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLIDRENEWTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'RenewalOptions', params: { serviceType: 'DLRENEW' } },
    tableHeaders: ['ID Number', 'Date of Birth', 'Years Renewed'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },
  RDLOPTIN: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLIDRENEWTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'RenewalOptions', params: { serviceType: 'RDLOPTIN' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },
  RIDOPTIN: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLIDRENEWTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'RenewalOptions', params: { serviceType: 'RIDOPTIN' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },
  IDRENEW: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLIDRENEWTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'RenewalOptions', params: { serviceType: 'IDRENEW' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },

  DLDUP: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLDUPTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'DuplicateOptions', params: { serviceType: 'DLDUP' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },

  IDDUP: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'IDDUPTRNCMPTXT',
    printProduct: false,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'DuplicateOptions', params: { serviceType: 'IDDUP' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },

  DLCOA: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLCOATRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'COAChangeAddress' },
    tableHeaders: ['ID Number', 'Date of Birth', 'Update Voter Registration'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },

  VRCOA: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'VRCOATRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: { name: 'COAVerifyIdentity' },
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: true,
    canAddServices: true,
    hasLineItems: false,
  },

  DLRESTOREREQLTR: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'DOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-id-card-fill',
    editPage: '',
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  DLRESTORFEE: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-id-card-fill',
    editPage: '',
    tableHeaders: ["Driver's License Number", 'Date of Birth'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  VRRENEW: {
    cartInstructions: 'DOCINCARTTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Plate Number', 'Title Number', 'Years Renewed'],
    editable: false,
    canAddServices: true,
    hasLineItems: true,
  },

  VRDUP: {
    cartInstructions: 'DOCINCARTTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: false,
    canAddServices: true,
    hasLineItems: true,
  },

  VRRESTOREREQLTR: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  VRRESTORFEE: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  VRLOCALFEE: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'VRLOCLUSEFEETRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  PROOFOFINSUR: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-contract-fill',
    editPage: { name: 'AddInsuranceInfo' },
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: true,
    canAddServices: true,
    hasLineItems: false,
  },

  PAYCIVILPENALFEE: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },
}

export const RENEWAL_YEARS_LABEL = {
  '2YRREDCOST': '2',
  '4YRFULLCOST': '4',
}

export const headerValueExtractors = {
  "Driver's License Number": (item) => item.idNumber || '',
  'ID Number': (item) => item.idNumber || '',
  'Date of Birth': (item, fmt) => fmt(item.dob) || '',
  Amount: (item) => `$${(item.totalAmount || 0).toFixed(2)}`,
  'Identification Type': (item) => getDLTypeDescription(item.idType),
  'Update Voter Registration': (item) => (item.motorVoterCoa ? 'Yes' : 'No'),
  Address: (item) => [item.address1, item.poBox, item.city, item.state, item.zip].filter(Boolean).join(', '),
  'Fee ID': (item) => item.idNumber || '',
  'Title Number': (item) => item.titleNumber || '',
  'Plate Number': (item) => item.tagNumber || '',
  'Retired Rate': (item) => (['Y', '1'].includes(item.retireInd) ? 'Yes' : ''),
  VIN: (item) => item.vinNumber || '',
  'Donor ID': (item) => item.idNumber || '',
  Date: (item, fmt) => fmt(item.dob) || '',
  'Years Renewed': (item, _fmt, tempTransactionDetails) =>
    RENEWAL_YEARS_LABEL[tempTransactionDetails?.renewalYears] || tempTransactionDetails?.renewalYears || '',
}

export const DONATION_FIELD_MAP = {
  DONATEODTF: 'dlDonateOdtf',
  DONATEPBCC: 'dlDonatePbcc',
  DONATEPCRF: 'dlDonatePcrf',
  DONATEVTF: 'dlDonateVtf',
  DONATECTF: 'dlDonateCtfd',
  DONATEKTF: 'dlDonateKtf',
}

// Used in feeCalc to map donation fields for vehicle services
export const VEHICLE_DONATION_FIELD_MAP = {
  DONATEODTF: 'vsDonateOdtf',
  DONATEPBCC: 'vsDonatePbcc',
  DONATEPCRF: 'vsDonatePcrf',
  DONATEVTF: 'vsDonateVtf',
  DONATECTF: 'vsDonateCtfd',
  DONATEKTF: 'vsDonateKtf',
}

const SERVICE_RENEWAL_LABEL = {
  DLRENEW: "Driver's License Renewal",
  IDRENEW: 'Photo ID Renewal',
  DLDUP: "Driver's License/Camera Card Duplicate",
  IDDUP: 'Photo ID/Camera Card Duplicate',
  RDLOPTIN: "Driver's License REAL ID Opt In",
  RIDOPTIN: 'Photo ID REAL ID Opt In',
}

const REAL_ID_OPT_IN_SERVICES = new Set(['RDLOPTIN', 'RIDOPTIN'])

export const buildVRDuplicateLineItems = (duplicateCount) => [
  { title: `${duplicateCount ?? 0} Registration Cards @ $0.00 each`, price: 0, category: 'Service Fees' },
]

export const buildRenewalLineItems = (item, tempTransactionDetails = {}, referenceValues = []) => {
  const { feeData, addOrganDonor, addVeteransDesignation } = tempTransactionDetails

  if (item.serviceType === 'VRDUP') {
    return buildVRDuplicateLineItems(tempTransactionDetails.duplicateCount ?? item.duplicates)
  }

  if (item.serviceType === 'DLCOA' || item.serviceType === 'IDCOA') {
    const idLabel = getDLTypeDescription(item.idType) || "Driver's License"
    return [{ title: `${idLabel} Change of Address`, price: 0, category: 'Service Fees' }]
  }
  if (item.serviceType === 'VRCOA') {
    return [{ title: 'Vehicle Registration Change of Address', price: 0, category: 'Service Fees' }]
  }

  if (!feeData) return []

  const donationLabelByApiField = Object.fromEntries(
    referenceValues
      .filter((ref) => DONATION_FIELD_MAP[ref.value])
      .map((ref) => [DONATION_FIELD_MAP[ref.value], ref.altDescription]),
  )

  if (item.serviceType === 'VRRENEW') {
    return [
      ...buildVRRenewalFeeItems(feeData, tempTransactionDetails.duplicateCount),
      ...(tempTransactionDetails.selectedDonations ?? [])
        .filter((donationId) => feeData[VEHICLE_DONATION_FIELD_MAP[donationId]] > 0)
        .map((donationId) => ({
          title: referenceValues.find((donation) => donation.value === donationId)?.altDescription,
          price: feeData[VEHICLE_DONATION_FIELD_MAP[donationId]],
          category: 'Donation(s)',
        })),
    ]
  }

  const items = [
    {
      title: `${SERVICE_RENEWAL_LABEL[item.serviceType]} Fee`,
      price: feeData.baseFee,
      category: 'Service Fees',
    },
  ]

  if (REAL_ID_OPT_IN_SERVICES.has(item.serviceType) && feeData.realIdOptinFee > 0) {
    items.push({
      title: 'REAL ID Opt In One-Time Fee',
      price: feeData.realIdOptinFee,
      category: 'Service Fees',
    })
  }

  if (addOrganDonor) {
    items.push({ title: 'Organ Donor', price: 0, category: 'Designations' })
  }

  if (addVeteransDesignation) {
    items.push({ title: "Veteran's Designation", price: 0, category: 'Designations' })
  }

  items.push(...buildDonationItems(item, feeData, donationLabelByApiField))

  return items
}

const buildDonationItems = (item, feeData, donationLabelByApiField) =>
  Object.entries(donationLabelByApiField)
    .filter(([apiField]) => feeData[apiField] > 0 && item[apiField] === true)
    .map(([apiField, label]) => ({ title: label, price: feeData[apiField], category: 'Donation(s)' }))

const buildVRRenewalFeeItems = (feeData, duplicateCount) => {
  const items = [{ title: 'Renewal Fee', price: feeData.baseFee ?? 0, category: 'Service Fees' }]

  if (feeData.localUseFee > 0) {
    items.push({ title: 'County Local Use Fee', price: feeData.localUseFee, category: 'Service Fees' })
  }

  const duplicates = duplicateCount ?? 0
  if (duplicates > 0) {
    const duplicateFee = feeData.duplicateFee ?? 0
    items.push({
      title: `${duplicates} Duplicates @ $${duplicateFee.toFixed(2)} each`,
      price: duplicates * duplicateFee,
      category: 'Service Fees',
    })
  }

  return items
}
